// The demo's client universe — consistent with the Company Brain scenarios.

export interface DemoClient {
  id: string;
  name: string;
  status: string;
  context?: string;
  system_prompt?: string;
  mssql_client_id?: string;
  vat_code?: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  last_synced?: string;
}

export const demoClients: DemoClient[] = [
  {
    id: 'client-romil',
    name: 'Ромил ООД',
    status: 'active',
    context: 'Търговия и монтаж, ~40 фактури/месец. ДМА се разделя от гаранции; гориво на управителя = служебен разход (договор за наем + пътни листове).',
    mssql_client_id: 'MirageFirm212',
    vat_code: 'BG204558712',
    user_id: 'demo-user-1',
    created_at: '2025-09-01T08:00:00Z',
    updated_at: '2026-07-01T08:00:00Z',
    last_synced: '2026-07-05T06:00:00Z',
  },
  {
    id: 'client-artemis',
    name: 'Артемис Дизайн ЕООД',
    status: 'active',
    context: 'Графичен дизайн и брандинг (B2B). Нов клиент от 01.07.2026 — начални салда прехвърлени, конвенциите тепърва се учат.',
    mssql_client_id: 'MirageFirm305',
    vat_code: 'BG207114458',
    user_id: 'demo-user-1',
    created_at: '2026-07-01T08:00:00Z',
    updated_at: '2026-07-04T08:00:00Z',
    last_synced: '2026-07-05T06:00:00Z',
  },
  {
    id: 'client-globaltrans',
    name: 'Глобал Транс ЕООД',
    status: 'active',
    context: 'Транспорт и спедиция.',
    mssql_client_id: 'MirageFirm118',
    vat_code: 'BG201334892',
    user_id: 'demo-user-1',
    created_at: '2025-11-12T08:00:00Z',
    updated_at: '2026-06-20T08:00:00Z',
    last_synced: '2026-07-05T06:00:00Z',
  },
  {
    id: 'client-vertigo',
    name: 'Вертиго Студио ООД',
    status: 'active',
    context: 'Архитектурно студио.',
    mssql_client_id: 'MirageFirm097',
    vat_code: 'BG200987114',
    user_id: 'demo-user-1',
    created_at: '2025-10-03T08:00:00Z',
    updated_at: '2026-06-28T08:00:00Z',
    last_synced: '2026-07-05T06:00:00Z',
  },
  {
    id: 'client-bgmebel',
    name: 'БГ Мебел АД',
    status: 'active',
    context: 'Производство на мебели, износ за ЕС.',
    mssql_client_id: 'MirageFirm201',
    vat_code: 'BG121887345',
    user_id: 'demo-user-1',
    created_at: '2025-08-15T08:00:00Z',
    updated_at: '2026-07-02T08:00:00Z',
    last_synced: '2026-07-05T06:00:00Z',
  },
];
